import z from "zod";

export const NamedConceptSchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string(),
  tenantId: z.string(),
  organizationId: z.string(),
  workspaceId: z.string(),
  projectId: z.string(),
  createdBy: z.string(),
  createdAt: z.string(),
  modifiedBy: z.string(),
  modifiedAt: z.string(),
  isArchived: z.boolean().optional(),
  grants: z.record(z.string(), z.boolean()).optional(),
});

export const CreateNamedConceptInputSchema = z.object({
  name: z.string().min(2).max(256),
  description: z.string().max(512),
});
